import { Component } from '@angular/core';
import { BaseComponentContext } from '../../../../modules/tcm-core.module';
import { BroadCastEvents } from '../../../../common/broad-cast-events.enum';
import { BrandDataService } from '../../../../services/brand-data.service';
import { UpdateBrandLogoRequest } from '../../../../models/brands';

@Component({
    selector: 'update-brand-logo',
    templateUrl: './update-brand-logo.component.html',
    styleUrls: ['./update-brand-logo.component.scss'],
    standalone: false
})
export class UpdateBrandLogoComponent {
  public requestModel: any;

  public isLoading: boolean;

  public base64img: string;

  public constructor(private componentContext: BaseComponentContext, private brandDataService: BrandDataService) {
  }

  goBack(data?: any) {
    this.componentContext.navService.navigateBack(data);
  }

  public async save() {
    if (this.base64img) {
      var request = {} as UpdateBrandLogoRequest;

      request.brandId = this.requestModel.brandId;
      request.base64string = this.base64img;

      try {
        this.isLoading = true;
        await this.brandDataService.updateBrandLogoAsync(request);
      }
      finally {
        this.isLoading = false;
      }

      this.componentContext.broadcastService.next({ name: BroadCastEvents.BrandLogoChanged, args: { src: this.base64img } });
      this.goBack();
    }
  }

  public onPictureLoaded(args: any) {
    this.base64img = args.base64string;
  }
}
